<h2 mat-dialog-title class="confirm-dialog-title">
  <span class="confirm-dialog-title__accent" aria-hidden="true"></span>
  {{ data.title || "Confirmar accion" }}
</h2>

<mat-dialog-content class="mat-typography confirm-dialog-content">
  <p>{{ data.text }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end" class="confirm-dialog-actions">
  <button mat-stroked-button type="button" (click)="close()">No</button>
  <button
    mat-raised-button
    color="primary"
    type="button"
    (click)="confirm()"
    cdkFocusInitial
  >
    Sí, confirmar
  </button>
</mat-dialog-actions>
